import { render, staticRenderFns } from "./POI.vue?vue&type=template&id=ae393e8c"
import script from "./POI.vue?vue&type=script&lang=js"
export * from "./POI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports